import { createFileRoute } from "@tanstack/react-router";
import { DataSettings } from "@/features/jobs/data-settings";

export const Route = createFileRoute("/_app/settings/data")({
  head: () => ({ meta: [{ title: "Data & privacy · Settings · Malfak" }] }),
  component: DataSettings,
});
